import { render } from "./ProgrammeOwnerForm.vue?vue&type=template&id=5608dd9c"
import script from "./ProgrammeOwnerForm.vue?vue&type=script&lang=js"
export * from "./ProgrammeOwnerForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__